"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
const error_1 = require("./error");
class Environment {
    constructor(enclosing) {
        this.enclosing = enclosing;
        this.values = new Map();
    }
    define(name, value) {
        this.values.set(name, value);
    }
    get(interpreter, name) {
        if (this.values.has(name.lexeme)) {
            return this.values.get(name.lexeme);
        }
        if (this.enclosing) {
            return this.enclosing.get(interpreter, name);
        }
        throw new error_1.RuntimeError(name, `Undefined variable name '${name.lexeme}'`);
    }
    getAt(distance, name) {
        return this.ancestor(distance).values.get(name);
    }
    assign(name, value) {
        if (this.values.has(name.lexeme)) {
            this.define(name.lexeme, value);
            return;
        }
        if (this.enclosing) {
            this.enclosing.assign(name, value);
        }
        throw new error_1.RuntimeError(name, `Undefined variable name '${name.lexeme}'`);
    }
    assignAt(distance, name, value) {
        this.ancestor(distance).values.set(name.lexeme, value);
    }
    ancestor(distance) {
        let current = this;
        for (let i = 0; i < distance; i++) {
            current = current.enclosing;
        }
        return current;
    }
}
exports.Environment = Environment;
